module.exports = __webpack_public_path__ + "img/border_right_arrow.dd81feab.svg";